/* ReservationWrapper - Runs Reservation if we're on Reservation page. */
import * as Reservation from "../../../output/Restaumatic.Site.Components.Reservation/index.js";
function init() {
    const container = document.getElementById("ps-reservation");
    if (!container)
        return; // not a Reservation page
    const settings = {
        container,
    };
    const exports = Reservation.run(settings)();
    const currentVal = Skubacz.configuration.restaurant_slug;
    // if there's one restaurant, provide restaurant slug
    if (currentVal) {
        exports.selectedRestaurantSlug(currentVal)();
    }
    else {
        // if more, callback on selection
        const restaurantSelect = document.getElementById("reservation-form__restaurant");
        if (!restaurantSelect)
            return; // sites with one restaurant don't have restaurant select
        exports.selectedRestaurantSlug(restaurantSelect.value)();
        document.addEventListener("change-restaurant.restaumatic", (e) => {
            exports.selectedRestaurantSlug(e.detail.slug)();
        });
    }
}
export default {
    init,
};
